export enum LogoType {
  HOME = 'home',
  HEADER = 'header',
  DOCUMENT = 'document',
  SMALL = 'small',
  FAVICON = 'favicon',
  DEFAULT = 'default',
}
